import axios from '@/api/$axios'
export default {
  login ({ organizationId, mobile, smsCode, password }) {
    return axios.post(`/logins`, {
      organizationId, mobile, smsCode, password
    })
  },
  loginByWx ({ organizationId, wxCode, temporaryCode, mobile, smsCode, password }) {
    return axios.post(`/logins/by_wechat`, {
      organizationId, wxCode, temporaryCode, mobile, smsCode, password
    })
  },
  get () {
    return axios.get(`/user`)
  },
  update ({ mobile, avatar, nickname }) {
    return axios.put(`/user`, {
      user: {
        mobile, avatar, nickname
      }
    })
  }
}
